import { useSuspenseQuery } from '@apollo/client';
import React, { Suspense } from 'react';
import { Link, useLocation } from 'react-router-dom';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
  LoadingIndicator,
} from '@eluve/components';
import { getTenantNameQuery, useTenantName } from '@eluve/smart-blocks';

const TenantBreadCrumbsContent: React.FC<{
  tenantId: string;
  appointmentId?: string;
}> = ({ tenantId, appointmentId }) => {
  useSuspenseQuery(getTenantNameQuery, {
    variables: {
      tenantId,
    },
  });

  const location = useLocation();

  const isTenantRoute = location.pathname.endsWith(tenantId);
  const tenantName = useTenantName(tenantId);

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {!isTenantRoute && (
          <>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to={`/admin/organizations/${tenantId}`}>
                  {tenantName}
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
          </>
        )}
        {Boolean(appointmentId) && (
          <>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to={`/admin/organizations/${tenantId}/appointments`}>
                  Appointments
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export const TenantBreadCrumbs: React.FC<{
  tenantId: string;
  appointmentId?: string;
}> = ({ tenantId, appointmentId }) => {
  return (
    <Suspense fallback={<LoadingIndicator size="xl" />}>
      <TenantBreadCrumbsContent
        tenantId={tenantId}
        appointmentId={appointmentId}
      />
    </Suspense>
  );
};
